



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { UAParser } from 'ua-parser-js';

import { User, WebSocketInfo } from '@/common/Users';
import { Features } from '@/services/Features';

// import ScreenShare from './ScreenShare.vue';

@Component({
	name: 'UserDetails',
	components: {
		// ScreenShare,
	},
})
export default class UserDetails extends Vue {
	@Prop() private user: User;
	@Prop() private loading: boolean;
	@Prop() private error: boolean;

	private readonly Features = Features;

	private get uaParser(): UAParser | undefined {
		const mruWebsocket: WebSocketInfo | undefined = Object.values(this.user.websockets).reduce(
			(prev, curr) => (!prev || curr.last_seen > prev.last_seen ? curr : prev),
			undefined,
		);

		return mruWebsocket?.user_agent && new UAParser(mruWebsocket.user_agent);
	}
}
